import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import MasterDocumentTypesModal from './master-document-types-modal';
import { deleteDocumentType, getDocumentType, getMasterData } from '../actions';
import Alert from 'react-s-alert';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SortingCustom from '../../../../../components/SortingCustom';
import GlobalVariables, { resetFiltersAndSorting, alertConfirmation } from '../../../../../actions/utilAction';

class MasterDocumentTypesList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      documentTypeId: null,
    };
    this.filter = {
      sort_Column: 'id',
      searchText: '',
      sort_order: 'desc',
    };

    this.handleSearchDocumentType = this.handleSearchDocumentType.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'id',
      sort_order: this.filter.sort_order ? this.filter.sort_order : 'asc',
      contain_filters: { SearchText: this.filter.searchText ? this.filter.searchText : undefined },
      pageNumber: page_number ? page_number : 1,    
      pageSize: GlobalVariables.PageSize,
    };
    this.props.getDocumentType(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.postDocumentType && this.props.postDocumentType !== nextProps.postDocumentType) {
      this.loadData();
    }
    if (nextProps.DeleteDocumentType && this.props.DeleteDocumentType !== nextProps.DeleteDocumentType) {
      this.loadData();
    }
  }
  componentWillMount() {
    this.loadData();
    const masterData = { masterdata: 'MASTERROLES,MASTERINSURANCECOMPANY' };
    this.props.getMasterData(masterData);
  }

  componentWillUnmount() {
    Alert.closeAll();
  }
  handleReset = () => {
    Alert.closeAll();
    this.props.dispatch(reset('MasterDocumentTypesListForm'));
    resetFiltersAndSorting(this.filter, 'id', false);
    this.setState({
      Type: null,
    }, () => {
      this.loadData();
    });
  };
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, documentTypeId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleAlertClick = (event, id) => {
    this.props.deleteDocumentType(id);
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {

    alertConfirmation('Are you sure you want to delete the document type ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ open: true, documentTypeId: obj.id });
    // console.log("role data.......",);
  }

  handleSearchDocumentType(event) {
    if (event.DocumentType !== undefined) {
    }
  }

  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }

  renderData() {
    return this.props.documentTypes.map((Obj, index) => {
      return (
        <tr key={index}>
          <td>{Obj.type}</td>          
          <td className={Obj.isRequiredDocument === true ? 'greenfont' : 'redfont'}>{Obj.isRequiredDocument === true ? 'Yes' : 'No'}</td>
          <td className={Obj.isActive === true ? 'greenfont' : 'redfont'}>{Obj.isActive === true ? 'Active' : 'Inactive'}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });

    return (
      <div>
        <h2 className="page_title">Manage Staff Document Types</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Document Type" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchDocumentType)}>
                        <Field
                          name="Type"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton label="Reset" className="grey_btn ml_15" onTouchTap={this.handleReset} />
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <MasterDocumentTypesModal documentTypeId={this.state.documentTypeId} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  {this.props.documentTypes ? this.props.documentTypes.length ?
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="40%"><SortingCustom setSortColumn={this.setSortColumn} columnName='Type' displayName='Document Type' /></th>
                          <th width="20%">Required</th>
                          <th width="20%">Status</th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="20%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderData()}
                      </tbody>
                    </table>
                    :
                    <table className={tableClass}>
                      <thead>
                        <tr>
                          <th width="40%">Document Type</th>
                          <th width="20%">Required Document</th>
                          <th width="20%">Status</th>
                          {this.props.updatePermission || this.props.deletePermission ?
                            <th width="20%">Actions</th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="3">
                            <div className="familydl text-center no-record">No record found.</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}
                  {this.props.metaData && this.props.metaData.totalPages ?
                    <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MasterDocumentTypesList = reduxForm({
  form: 'MasterDocumentTypesListForm',
})(MasterDocumentTypesList);

function mapStateToProps(state) {
  // console.log('state.documentTypes......', state.documentTypes);
  // Start For Role Permission
  let userActionPermission = [], documentTypes = [], metaData = null;
  if (state.masterDocumentTypes.getDocumentTypes && state.masterDocumentTypes.getDocumentTypes.data) {
    documentTypes = state.masterDocumentTypes.getDocumentTypes.data;
    metaData = state.masterDocumentTypes.getDocumentTypes.meta;
    // console.log('state', state.diagnosisCode.diagnosisCodesList.data);
  };
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_DOCUMENTTYPESSTAFF_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_DOCUMENTTYPESSTAFF_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_DOCUMENTTYPESSTAFF_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_DOCUMENTTYPESSTAFF_LIST_DELETE')[0].permission : false;

  // End For Role Permission
  return {
    documentTypes: documentTypes,
    postDocumentType: state.masterDocumentTypes.postDocumentType,
    DeleteDocumentType: state.masterDocumentTypes.deleteDocumentType,
    metaData: metaData,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}
export default connect(mapStateToProps, { getDocumentType, deleteDocumentType, getMasterData })(MasterDocumentTypesList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypesStaff/components/index.js